import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/01e39a610fd7766c3b9f6ecd6d37a7b6.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 font-cairo leading-tight">
          دليلك الشامل للقبول في
          <br />
          <span className="text-saudi-gold-400">الجامعات السعودية</span>
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-10 font-tajawal leading-relaxed max-w-3xl mx-auto">
          منصة رقمية مركزية تجمع جميع مواعيد وإجراءات القبول في المؤسسات التعليمية السعودية الحكومية والأهلية
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate('/opportunities')}
            className="bg-primary-600 text-white px-8 py-4 rounded-full font-tajawal font-bold text-lg hover:bg-primary-700 transition-all hover:scale-105 flex items-center gap-3 cursor-pointer whitespace-nowrap shadow-xl"
          >
            <span>استكشف الفرص المتاحة</span>
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          <button
            onClick={() => {
              const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
              if (widget) widget.click();
            }}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-tajawal font-bold text-lg hover:bg-white/20 transition-all border-2 border-white/30 flex items-center gap-3 cursor-pointer whitespace-nowrap"
          >
            <span>تحدث معنا</span>
            <i className="ri-customer-service-2-line text-xl"></i>
          </button>
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-3 gap-8 mt-20 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2 font-cairo">50+</div>
            <div className="text-white/80 font-tajawal">جامعة</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2 font-cairo">200+</div>
            <div className="text-white/80 font-tajawal">تخصص</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2 font-cairo">24/7</div>
            <div className="text-white/80 font-tajawal">دعم</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
